import { AxiosRequestConfig } from 'axios'

import { CreateCampaignPayload, UpdateCampaignPayload, DataParams } from './types'

const getCampaigns = (): AxiosRequestConfig => ({
  url: '/campaigns',
  method: 'GET',
})

const getCampaign = (id: number): AxiosRequestConfig => ({
  url: `/campaigns/${id}`,
  method: 'GET',
})

const createCampaign = (campaign: CreateCampaignPayload): AxiosRequestConfig => ({
  url: '/campaigns',
  method: 'POST',
  data: {
    campaign: {
      title: campaign.title || null,
      description: campaign.description || null,
      startDate: campaign.startDate,
      endDate: campaign.endDate || null,
      notificationId: campaign.notificationId || null,
      prizeId: campaign.prizeId || null,
      emailId: campaign.emailId || null,
      enabled: campaign.enabled,
      activeReward: campaign.activeReward,
      activePush: campaign.activePush,
      activeEmail: campaign.activeEmail,
      activePopUp: campaign.activePopUp,
      popUpImageId: campaign.popUpImageId || null,
      tagIds: campaign.tagIds || [],
      excludedTagIds: campaign.excludedTagIds || [],
      allTagsAreRequired: campaign.allTagsAreRequired,
      visitsOperator: campaign.visitsOperator || null,
      visitsValue: campaign.visitsValue || null,
      dateFrom: campaign.dateFrom || null,
      dateTo: campaign.dateTo || null,
      rewardId: campaign.rewardId || null,
      rewardInverted: campaign.rewardInverted,
      includeAbandoners: campaign.includeAbandoners ?? false,
    },
  },
})

const updateCampaign = (data: UpdateCampaignPayload): AxiosRequestConfig => ({
  url: `/campaigns/${data.id}`,
  method: 'PUT',
  data: {
    campaign: {
      title: data.title || null,
      description: data.description || null,
      startDate: data.startDate,
      endDate: data.endDate || null,
      notificationId: data.notificationId || null,
      prizeId: data.prizeId || null,
      emailId: data.emailId || null,
      enabled: data.enabled,
      activeReward: data.activeReward,
      activePush: data.activePush,
      activeEmail: data.activeEmail,
      activePopUp: data.activePopUp,
      ...(data.popUpImageId !== undefined ? { popUpImageId: data.popUpImageId || null } : {}),
      tagIds: data.tagIds || [],
      excludedTagIds: data.excludedTagIds || [],
      allTagsAreRequired: data.allTagsAreRequired,
      visitsOperator: data.visitsOperator || null,
      visitsValue: data.visitsValue || null,
      dateFrom: data.dateFrom || null,
      dateTo: data.dateTo || null,
      rewardId: data.rewardId || null,
      rewardInverted: data.rewardInverted,
      ...(data.includeAbandoners !== undefined
        ? { includeAbandoners: data.includeAbandoners }
        : {}),
    },
  },
})

const deleteCampaign = (id: number): AxiosRequestConfig => ({
  url: `/campaigns/${id}`,
  method: 'DELETE',
})

const getCampaignUsersEmails = (campaignId: number): AxiosRequestConfig => ({
  url: `/campaigns/${campaignId}/users-emails`,
  method: 'GET',
})

const fetchPushUserCount = ({
  visitsOperator,
  visitsValue,
  dateFrom,
  dateTo,
  rewardId,
  rewardInverted,
  tagIds,
  allTagsAreRequired,
  includeAbandoners,
  excludedTagIds,
}: DataParams): AxiosRequestConfig => {
  const params = {
    ...(visitsOperator ? { visitsOperator } : {}),
    ...(visitsValue !== undefined ? { visitsValue } : {}),
    ...(dateFrom ? { dateFrom } : {}),
    ...(dateTo ? { dateTo } : {}),
    ...(rewardId ? { rewardId } : {}),
    ...(rewardInverted ? { rewardInverted } : {}),
    ...(tagIds ? { tagIds } : {}),
    ...(excludedTagIds ? { excludedTagIds } : {}),
    ...(allTagsAreRequired !== undefined ? { allTagsAreRequired } : {}),
    ...(includeAbandoners !== undefined ? { includeAbandoners } : {}),
  }

  return {
    url: '/campaigns/user-count',
    method: 'GET',
    params,
  }
}

const uploadPopUpImage = (file: File): AxiosRequestConfig => {
  const payload = new FormData()
  payload.append('popUpImage', file)

  return {
    url: '/campaigns/pop-up-image',
    method: 'POST',
    data: payload,
  }
}

export {
  getCampaigns,
  getCampaign,
  createCampaign,
  updateCampaign,
  deleteCampaign,
  getCampaignUsersEmails,
  fetchPushUserCount,
  uploadPopUpImage,
}
